<script>
  import ApplicationState from "../../../Stores/applicationStates"
  import singlePublish, { removeDataSinglePublish } from "../../Publish/SinglePublish/Stores/singlePublishStore"
  import Navbar from "../../../Shared/Navbar/index.svelte"
  import Footer from "../../../Shared/footer.svelte"
  import notify from "../../../Script/notify"
  import Table from "../../../Shared/Table/table.svelte"
  import List from "./Components/list.svelte"
  import FilterComponent from "../Document/Components/filterComponent.svelte"
  import { onDestroy, onMount } from "svelte"
  import LoadingScreen from "../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../Script/queryString"
  import ReleaseData from "./Stores/releaseDoc"
  import BulkReleaseModal from "./Components/bulkReleaseModal.svelte"
  import { releaseDocumentId } from "../../Publish/SinglePublish/script"
  import { getRequest } from "../../../Script/apiMethods"
  let query = queryStringToJSON($querystring)

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let apiCallBtnDisable = false

  /**
   * @type {Number} - how many list need to show
   */
  let limit

  /**
   * @type {Number} - which page list need to show
   */
  let page

  /**
   * @type {Number} - which order need to show (in order to date)
   */
  let sort

  /**
   * @type {Number} - which sory type need to show (date or name)
   */
  let sortBy

  /**
   * @typedef {Object} search - it contains what user want to search (searchvalue) in which parameter (searchParam)
   * @type {Object}
   * it contains what user want to search (searchvalue) in which parameter (searchParam)
   *
   * @property {String} searchvalue - what value need to search.
   * @property {String} searchParam - on which param need to show
   */
  let search = {
    searchParam: "name",
    searchvalue: "",
  }

  /**
   * @type {String} - from date of filter list
   */
  let startDate = null

  /**
   * @type {String} - to date of filter list
   */
  let endDate = null

  /**
   * @type {String} - which state document need to show
   */
  let status = null

  let mode = "all"

  /**
   * @type {Object} - response for fetch document api call
   */
  let DocumentList = {
    documents: [],
  }
  /**
   * @type {Boolean} for disabling the input box
   */
  let disableCheckBox
  /**
   * @type {Boolean} disabling the group check box
   */
  let disableGroupCheckBox
  /**
   * @type {Boolean} whether to show bulk release modal or not
   */
  let showBulkReleaseModal = false
  /**
   * @type {String} text to be shown while loading
   */
  let loadingText = "Fetching Pending Documents List"
  /**
   * @type {Array<String>} array of document ID's to be released
   */
  let documentToBeReleased = []
  /**
   * @type {Array<String>} array of document ID's to be released in process
   */
  let releaseInProcess = []

  /**
   * Initial values are assigned
   */
  onMount(async () => {
    try {
      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      sortBy = query.sortBy ? query.sortBy : "date"
      startDate = query.sdate ? query.sdate : ""
      endDate = query.edate ? query.edate : ""
      status = query.state ? query.state : "all"
      mode = query.mode ? query.mode : "all"
      search.searchParam = query.sin ? query.sin : "name"
      search.searchvalue = query.sname ? query.sname : ""
      await fetchDocuments()

      disableCheckBox = $ReleaseData.previouslySelected.length + $ReleaseData.selected.length >= 100
    } catch (error) {
      const info = "PAGE: Pending Documents\nEVENT: onMount"
      notify.danger(error, info)
    }
  })

  /**
   * @description function for fetch publsih process documents.
   */
  const fetchDocuments = async () => {
    try {
      apiCallBtnDisable = true

      const data = await getRequest(`/api/swagger/v2/documents?pending=true&limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}&mode=${mode}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      DocumentList = data

      push(`/documents/pending?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}&mode=${mode}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`)
    } catch (error) {
      // console.error(error)
      throw error
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description Function to fetch templates based on user input.
   */
  const whileChangingEntries = async (e) => {
    try {
      if (e.detail.entries) limit = e.detail.entries
      if (e.detail.activePage) page = e.detail.activePage
      if (e.detail.sort) sort = e.detail.sort
      if (e.detail.sortBy) sortBy = e.detail.sortBy
      if (e.detail.filter.mode) mode = e.detail.filter.mode
      if (e.detail.filter.date.status) {
        status = e.detail.filter.date.status
        startDate = e.detail.filter.date.startDate ? e.detail.filter.date.startDate : ""
        endDate = e.detail.filter.date.endDate ? e.detail.filter.date.endDate : ""
      }
      if (e.detail.filter.search.searchParam) {
        search.searchParam = e.detail.filter.search.searchParam
        search.searchvalue = e.detail.filter.search.searchvalue
      }
      await fetchDocuments()

      $ReleaseData.previouslySelected = [...$ReleaseData.previouslySelected, ...$ReleaseData.selected]

      $ReleaseData.selected = []

      let disableGrpBtn = true

      DocumentList.documents.filter((a) => {
        for (let i = 0; i < $ReleaseData.previouslySelected.length; i++) {
          if (a.id == $ReleaseData.previouslySelected[i]) {
            disableGrpBtn = false
            $ReleaseData.selected.push($ReleaseData.previouslySelected[i])
            $ReleaseData.previouslySelected = $ReleaseData.previouslySelected.filter((a) => a != $ReleaseData.previouslySelected[i])
          }
        }
      })

      disableCheckBox = $ReleaseData.previouslySelected.length + $ReleaseData.selected.length >= 100

      if (disableGrpBtn) disableGroupCheckBox = $ReleaseData.previouslySelected.length + $ReleaseData.selected.length >= 100
      else disableGroupCheckBox = false

      $ReleaseData.selectChecked = $ReleaseData.selected.length == limit
    } catch (error) {
      const info = "PAGE: Pending Documents\nEVENT: Error occurred during actions such as sorting by date/ name, changing display entries, changing date filter, searching by name/ id/ status, or navigating pages."
      notify.danger(error, info)
    }
  }

  /**
   * @description Function to reset the user inputs
   */
  const resetList = async () => {
    try {
      limit = 10
      page = 1
      sort = -1
      sortBy = "date"
      search.searchvalue = ""
      search.searchParam = "name"
      startDate = ""
      endDate = ""
      status = "all"
      mode = "all"
      await fetchDocuments()
    } catch (error) {
      const info = "PAGE: Pending Documents\nEVENT: Error occurred while resetting filter."
      notify.danger(error, info)
    }
  }

  /**
   * @description Function for release documents in the form of bulk
   */
  const startBulkRelease = async () => {
    // Check if there is data in jsonData, documents to be processed, or files in process
    if (documentToBeReleased.length || releaseInProcess.length) {
      // Call the function to assign data to the appropriate arrays for further processing
      assignData2Array()
    } else {
      $ReleaseData.selectChecked = false
      apiCallBtnDisable = false
      loadingText = "Fetching Pending Documents List"
      console.timeEnd("start") // End the timing for the "initiate" console time
      notify.success(`Selected Documents released successfully.`)

      await fetchDocuments()
    }
  }

  /**
   * @description Function for assigning data to respective array
   */
  const assignData2Array = () => {
    // Get the number of available hardware threads or cores
    let hwc = window.navigator.hardwareConcurrency

    // Assign files to the releaseInProcess array if it has fewer elements than the available hardware threads
    if (releaseInProcess.length < hwc) {
      // Extract a portion of jsonData to fill up to (hwc - releaseInProcess.length) elements
      let rArray = documentToBeReleased.splice(0, hwc - releaseInProcess.length)

      // Add the extracted elements to the releaseInProcess array
      releaseInProcess = [...releaseInProcess, ...rArray]

      // Process each element of fArray by calling the getFileHash function
      for (let i = 0; i < rArray.length; i++) {
        releaseIndividualDoc(rArray[i])
      }
    }
    // Initiate the process by requesting the next animation frame
    window.requestAnimationFrame(startBulkRelease)
  }

  /**
   * @description Function for release documents
   */
  const releaseIndividualDoc = async (id) => {
    try {
      console.log({ id })
      await releaseDocumentId(id)
      await removeDataSinglePublish(id)
      if (id == $singlePublish.documentId) $singlePublish = {}
    } catch (error) {
      console.error(error)
      const info = "PAGE: Pending Documents\nEVENT: While releasing single document."
      notify.danger(error, info)
    } finally {
      releaseInProcess = releaseInProcess.filter((a) => a != id)
    }
  }

  $: checkDisableState($ReleaseData.selected)

  const checkDisableState = (selected) => {
    disableCheckBox = $ReleaseData.previouslySelected.length + $ReleaseData.selected.length >= 100
  }

  const updateSelectAllStatus = () => {
    if (DocumentList.documents.length) {
      if ($ReleaseData.selectChecked) {
        let tempArray = []
        if (!$ReleaseData.previouslySelected.length) {
          tempArray = DocumentList.documents.filter((item) => !item.docket).map((a) => a.id)
          // DocumentList.documents.filter((a) => tempArray.push(a.id))
        } else {
          let filteredArr = DocumentList.documents.slice(0, 100 - $ReleaseData.previouslySelected.length)
          // filteredArr.filter((a) => tempArray.push(a.id))
          tempArray = filteredArr.documents.filter((item) => !item.docket).map((a) => a.id)
        }
        $ReleaseData.selected = [...tempArray]
      } else {
        $ReleaseData.selected = []
      }
    }
    console.log($ReleaseData.selected)
  }

  onDestroy(() => {
    localStorage.removeItem("P2BReleaseDoc")
  })
</script>

<svelte:head>
  <title>Pending Documents</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  {#if showBulkReleaseModal}
    <BulkReleaseModal
      on:click={() => {
        showBulkReleaseModal = false
      }}
      on:clear={() => {
        $ReleaseData.selected = $ReleaseData.previouslySelected = []
        disableGroupCheckBox = $ReleaseData.selectChecked = showBulkReleaseModal = false
      }}
      on:start={() => {
        disableGroupCheckBox = $ReleaseData.selectChecked = showBulkReleaseModal = false
        console.time("start")
        apiCallBtnDisable = true
        loadingText = "Releasing Selected Documents"

        documentToBeReleased = [...$ReleaseData.selected, ...$ReleaseData.previouslySelected]
        $ReleaseData.selected = $ReleaseData.previouslySelected = []
        startBulkRelease()
      }}
    />
  {/if}
  {#if apiCallBtnDisable}
    <LoadingScreen msg={loadingText} />
  {/if}
  <div class="px-6">
    <div class="relative mx-auto mb-40 mt-10 h-full w-full max-w-[920px]">
      <!-- <div class="relative mx-auto mb-40 mt-10 h-fit w-full px-6 md:w-4/5 md:px-0 xl:w-3/5"> -->
      <Table
        on:releaseEntries={() => {
          showBulkReleaseModal = true
        }}
        showReleaseBtn={true}
        on:groupSelect={updateSelectAllStatus}
        on:changeEntries={whileChangingEntries}
        on:resetEntries={resetList}
        title={"List of Pending Documents"}
        filterComponent={FilterComponent}
        count={DocumentList.count}
        jsonData={DocumentList.documents}
        filter={true}
        status={false}
        nameSort={true}
        mode={true}
        {disableGroupCheckBox}
      >
        {#if DocumentList.documents.length}
          {#each DocumentList.documents as json}
            <List
              {json}
              on:reload={fetchDocuments}
              on:fetchPendingList={async (e) => {
                $ReleaseData.selected = [...$ReleaseData.selected.filter((a) => a != e.detail)]
                await fetchDocuments()
              }}
            >
              {#if json.docket}
                <div data-tooltip="Multiple selection isn't supported. Release dockets one by one." tooltip-position="right" class="flex h-4 w-4 cursor-pointer items-center justify-center rounded-sm bg-yellow-500 text-xs text-white dark:text-gray-900">
                  <span>
                    <i class="fa-solid fa-info" />
                  </span>
                </div>
              {:else}
                <input title={disableCheckBox ? "Can't Select more than 100 documents" : ""} disabled={disableCheckBox && !$ReleaseData.selected.filter((a) => a == json.id).length} name="pending" value={json.id} bind:group={$ReleaseData.selected} type="checkbox" style="color-scheme:{$ApplicationState.darkMode ? 'dark' : ''}" class="h-4 w-4 cursor-pointer disabled:cursor-not-allowed" />
              {/if}
            </List>
          {/each}
        {:else}
          <div class="text-secondary2 select-none rounded-md bg-white py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There is no pending document</div>
        {/if}
      </Table>
    </div>
  </div>
  <Footer />
</div>
